/**
 * ViewIcon/index.js
 * desc: system icon used to hide/show password content
 * note: accessible icon-button (button + tooltip) by default; read-only renders a static glyph
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const ViewIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="view icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.view.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 22 15" xmlns="http://www.w3.org/2000/svg"><path d="M11 0C6 0 1.73 3.11 0 7.5 1.73 11.89 6 15 11 15s9.27-3.11 11-7.5C20.27 3.11 16 0 11 0zm0 12.5c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm-3-5c0-1.66 1.34-3 3-3s3 1.34 3 3-1.34 3-3 3-3-1.34-3-3z"/></svg>
    </IconButton>
);


export default ViewIcon;
